<template>
  <aside class="aside__top">
    <!-- <span
            class="iconfont icon-nav toggleNavCollapse"
            :class="{active:isSidebarNavCollapse}"
            @click="toggleNavCollapse"
        >
        </span> -->
    <div class="aside__top--right">
      <div class="email">
        <span class="iconfont icon-email"><i>40</i></span>
      </div>
      <div class="user-msg">
        <span class="user-name">iwen</span>
        <el-dropdown
          @command="handleCommand"
          :hide-on-click="false"
          trigger="click"
          placement="top"
        >
          <span class="el-dropdown-link">
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>个人中心</el-dropdown-item>
            <el-dropdown-item>修改密码</el-dropdown-item>
            <el-dropdown-item command="s">切换账号</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="quit-system" @click="loginOut">
        <span class="iconfont icon-quit"></span>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      :modal="false"
      width="30%"
      :before-close="handleClose"
    >
      <el-table :data="units" style="width: 100%">
        <el-table-column label="机构名称" width="180">
          <template slot-scope="scope">
            <i class="el-icon-time"></i>
            <span style="margin-left: 10px">{{ scope.row.organizeShorthand }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="姓名" width="180">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p>姓名: {{ scope.row.name }}</p>
              <p>住址: {{ scope.row.address }}</p>
              <div slot="reference" class="name-wrapper">
                <el-tag size="medium">{{ scope.row.name }}</el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column> -->
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" @click="enterUnit(scope.$index, scope.row)"
              >进入</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </aside>
</template>

<script>
import { mapState } from 'vuex'
import { checkLogin } from '@/api'
import store from "@/store/index"
import { fetchPermission } from "@/api/index"
import router,{ DynamicRoutes } from "@/router/index"
import dynamicRouter from "@/router/dynamic-router"
import { recursionRouter,setDefaultRoute } from "@/utils/recursion-router"
import { getInformation } from '../../../../api'

export default {
  data() {
    return {
      dialogVisible: false,
      units: []
    }
  },
  computed: {
    ...mapState(['isSidebarNavCollapse'])
  },
  methods: {
    toggleNavCollapse() {
      this.$store.commit('toggleNavCollapse')
    },
    loginOut() {
      this.$store.commit('LOGIN_OUT')
      /* 防止切换角色时addRoutes重复添加路由导致出现警告 */
      window.location.reload()
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    handleClick() {
      console.log('handleClick')
    },
    // handleCommand(command) {

    //     if(command === 's'){
    //         this.dialogVisible = true
    //     }

    // }
    async handleCommand(command) {
      if (command === 's') {
        this.dialogVisible = true
        const data = {
          username: '15683315070'
        }
        // 网络请求
        let result = await checkLogin(data)
        this.units = result

      }
    },
    

    async enterUnit(index, row) {
      console.log("row",row)
      
      // this.$store.commit('permission/CLEAR_PERMISSION')
      // this.$store.commit('permission/CLEAR_MENU')
      this.$store.commit('LOGIN_OUT')
      this.$store.commit('permission/CLEAR_PERMISSION')
      // 组装参数
      const data = {
        organizeId: row.organizeId,
        roleId: row.roleId
      }
      // 网络请求
      let result = await getInformation(data)
      console.log("result",result)
      this.$store.dispatch("permission/FETCH_PERMISSION")
    }
  }
}
</script>

<style lang="scss" scoped>
.aside__top {
  border-bottom: 1px solid #e5e5e5;
  height: 56px;
  line-height: 64px;
  position: fixed;
  left: 200px;
  top: 0;
  right: 0;
  background: #fff;
  z-index: 1000;
  transition: left 0.25s;
  .toggleNavCollapse {
    display: inline-block;
    margin-left: 8px;
    padding: 0 10px;
    font-size: 26px;
    vertical-align: middle;
    color: #333;
    cursor: pointer;
    transition: all 0.5s;
    &.active {
      transform: rotate(90deg);
    }
  }

  .aside__top--right {
    position: absolute;
    right: 10px;
    top: -1px;
    bottom: 0px;
    > div {
      position: relative;
      display: inline-block;
      text-align: center;
      vertical-align: middle;
      margin-left: 10px;
      padding: 0 15px;
      cursor: pointer;
      &:hover::after {
        transform-origin: 0 0;
        transform: scaleX(1);
      }
      &:first-child:before {
        border: none;
      }
      &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 2px;
        background: #ef4747;
        transform: scaleX(0);
        transform-origin: right 0;
        transition: transform 0.5s;
      }
      &::before {
        content: '';
        position: absolute;
        height: 20px;
        top: 50%;
        left: -8px;
        margin-top: -10px;
        border-left: 1px solid #ccc;
      }
      &.email {
        i {
          position: absolute;
          left: 18px;
          top: -12px;
          border-radius: 20px;
          background: red;
          color: #fff;
          text-align: center;
          font-size: 12px;
          line-height: 1.5;
          min-width: 20px;
          min-height: 20px;
        }
      }
      &.user-msg {
        .user-img {
          width: 34px;
          height: 34px;
          border-radius: 50%;
          vertical-align: middle;
        }
        .user-name {
          color: #758eb5;
          padding: 0 4px;
        }
      }
      .iconfont {
        position: relative;
        font-size: 24px;
        color: #758eb5;
      }
    }
  }
}
.breadcrumb-enter,
.breadcrumb-leave-active {
  opacity: 0;
  transform: translateX(20px);
}

.breadcrumb-enter-active,
.breadcrumb-leave-active {
  transition: all 0.6s;
}

.breadcrumb-leave-active {
  position: absolute;
}
</style>
